module.exports = __webpack_public_path__ + "static/media/sample_mll_last_mile_batch.f33cf708.csv";